// Lightweight i18n — ES (default) / EN
export const TRANSLATIONS = {
  es: {
    nav: {
      home: "Inicio",
      shop: "Tienda",
      contact: "Contacto",
      account: "Cuenta",
      cart: "Carrito",
      login: "Entrar",
      logout: "Salir",
      register: "Registro",
      admin: "Admin",
    },
    home: {
      eyebrow: "Taller artesanal · León, España",
      title: "Joyería esmaltada al fuego, pieza a pieza.",
      subtitle:
        "Cada pieza nace del cobre y la plata, y del fuego que fija el color para siempre. Esmalte vitrificado a 850°C, hecho a mano.",
      ctaShop: "Ver colección",
      ctaStory: "La técnica",
      categoriesTitle: "Categorías",
      featuredTitle: "Destacados",
      aboutTitle: "Esmalte al fuego",
      aboutText:
        "Una técnica milenaria: capas de vidrio molido se funden sobre metal a más de 800°C. Cada pieza es única e irrepetible — el fuego decide.",
    },
    shop: {
      title: "La colección",
      all: "Todo",
      searchPlaceholder: "Buscar pieza…",
      empty: "No hay piezas que coincidan.",
    },
    product: {
      addToCart: "Añadir al carrito",
      addedToCart: "Añadido al carrito",
      description: "Descripción",
      price: "Precio",
      stock: "Stock disponible",
      back: "Volver a la tienda",
    },
    cart: {
      title: "Tu carrito",
      empty: "Tu carrito está vacío.",
      emptyCta: "Explorar colección",
      subtotal: "Subtotal",
      total: "Total",
      base: "Base imponible",
      iva: "IVA",
      ivaIncluded: "IVA incluido",
      remove: "Quitar",
      checkout: "Finalizar compra",
      shippingDetails: "Datos de envío",
      shippingName: "Nombre completo",
      shippingEmail: "Email",
      shippingPhone: "Teléfono",
      shippingAddress: "Dirección",
      shippingCity: "Ciudad",
      shippingPostalCode: "Código postal",
      shippingCountry: "País",
      pay: "Pagar con tarjeta",
      processing: "Procesando…",
    },
    checkout: {
      verifying: "Verificando tu pago…",
      paid: "¡Pago confirmado! Gracias por tu pedido.",
      pending: "Tu pago está siendo procesado…",
      expired: "La sesión de pago expiró. Inténtalo de nuevo.",
      backShop: "Seguir comprando",
      yourOrder: "Tu pedido",
    },
    auth: {
      loginTitle: "Entrar a tu cuenta",
      loginSubtitle: "Bienvenida de vuelta",
      registerTitle: "Crear cuenta",
      registerSubtitle: "Pedidos, favoritos e historial.",
      email: "Email",
      password: "Contraseña",
      newPassword: "Nueva contraseña",
      name: "Nombre",
      submitLogin: "Entrar",
      submitRegister: "Crear cuenta",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      forgot: "¿Olvidaste tu contraseña?",
      forgotTitle: "Recupera tu contraseña",
      forgotSubtitle: "Te enviaremos un enlace para restablecerla.",
      forgotSubmit: "Enviar enlace",
      forgotSent: "Si la cuenta existe, recibirás un email en unos minutos.",
      resetTitle: "Nueva contraseña",
      resetSubtitle: "Elige una contraseña segura.",
      resetSubmit: "Guardar contraseña",
      resetDone: "Contraseña actualizada. Ya puedes entrar.",
    },
    account: {
      title: "Mi cuenta",
      orders: "Mis pedidos",
      empty: "Aún no tienes pedidos.",
      orderId: "Pedido",
      status: "Estado",
      total: "Total",
      date: "Fecha",
      invoice: "Factura PDF",
    },
    contact: {
      title: "Contacto",
      subtitle: "Estaremos encantados de leerte.",
      formName: "Nombre",
      formSurname: "Apellido",
      formEmail: "Email",
      formPhone: "Teléfono",
      formQuestion: "Cuéntanos…",
      submit: "Enviar mensaje",
      sent: "Gracias, hemos recibido tu mensaje.",
      address: "Dirección",
      web: "Web",
      addressLine: "C/ del Taller, 12 · León, España",
      webLine: "esmaltealfuegoguerrero.com",
    },
    admin: {
      dashboard: "Panel",
      products: "Productos",
      categories: "Categorías",
      orders: "Pedidos",
      contacts: "Contactos",
      visits: "Visitas",
      revenue: "Ingresos",
      ordersPaid: "Pedidos pagados",
      productsCount: "Productos",
      usersCount: "Clientes",
      mostViewed: "Más vistos",
      visitsLast7: "Visitas últimos 7 días",
      newProduct: "Nuevo producto",
      newCategory: "Nueva categoría",
      edit: "Editar",
      delete: "Eliminar",
      save: "Guardar",
      cancel: "Cancelar",
      settings: "Ajustes",
    },
    common: {
      loading: "Cargando…",
      currency: "€",
    },
  },
  en: {
    nav: {
      home: "Home",
      shop: "Shop",
      contact: "Contact",
      account: "Account",
      cart: "Cart",
      login: "Sign in",
      logout: "Sign out",
      register: "Sign up",
      admin: "Admin",
    },
    home: {
      eyebrow: "Artisan workshop · León, Spain",
      title: "Fired-enamel jewelry, piece by piece.",
      subtitle:
        "Each piece is born from copper, silver and the fire that fixes color forever. Vitreous enamel at 850°C, handmade.",
      ctaShop: "Browse collection",
      ctaStory: "The technique",
      categoriesTitle: "Categories",
      featuredTitle: "Featured",
      aboutTitle: "Fired enamel",
      aboutText:
        "An ancient craft: layers of ground glass fused on metal at over 800°C. Every piece is unique and unrepeatable — the fire decides.",
    },
    shop: {
      title: "The collection",
      all: "All",
      searchPlaceholder: "Search a piece…",
      empty: "No pieces match.",
    },
    product: {
      addToCart: "Add to cart",
      addedToCart: "Added to cart",
      description: "Description",
      price: "Price",
      stock: "In stock",
      back: "Back to shop",
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty.",
      emptyCta: "Browse collection",
      subtotal: "Subtotal",
      total: "Total",
      base: "Net total",
      iva: "VAT",
      ivaIncluded: "VAT included",
      remove: "Remove",
      checkout: "Checkout",
      shippingDetails: "Shipping details",
      shippingName: "Full name",
      shippingEmail: "Email",
      shippingPhone: "Phone",
      shippingAddress: "Address",
      shippingCity: "City",
      shippingPostalCode: "Postal code",
      shippingCountry: "Country",
      pay: "Pay with card",
      processing: "Processing…",
    },
    checkout: {
      verifying: "Verifying your payment…",
      paid: "Payment confirmed! Thank you for your order.",
      pending: "Your payment is being processed…",
      expired: "Checkout session expired. Please try again.",
      backShop: "Keep shopping",
      yourOrder: "Your order",
    },
    auth: {
      loginTitle: "Sign in",
      loginSubtitle: "Welcome back",
      registerTitle: "Create account",
      registerSubtitle: "Orders, favorites and history.",
      email: "Email",
      password: "Password",
      newPassword: "New password",
      name: "Name",
      submitLogin: "Sign in",
      submitRegister: "Create account",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      forgot: "Forgot your password?",
      forgotTitle: "Reset your password",
      forgotSubtitle: "We'll email you a reset link.",
      forgotSubmit: "Send link",
      forgotSent: "If the account exists, you'll receive an email shortly.",
      resetTitle: "New password",
      resetSubtitle: "Choose a strong password.",
      resetSubmit: "Save password",
      resetDone: "Password updated. You can sign in now.",
    },
    account: {
      title: "My account",
      orders: "My orders",
      empty: "No orders yet.",
      orderId: "Order",
      status: "Status",
      total: "Total",
      date: "Date",
      invoice: "Invoice PDF",
    },
    contact: {
      title: "Contact",
      subtitle: "We'd love to hear from you.",
      formName: "First name",
      formSurname: "Last name",
      formEmail: "Email",
      formPhone: "Phone",
      formQuestion: "Tell us…",
      submit: "Send message",
      sent: "Thanks, we received your message.",
      address: "Address",
      web: "Web",
      addressLine: "C/ del Taller, 12 · León, Spain",
      webLine: "esmaltealfuegoguerrero.com",
    },
    admin: {
      dashboard: "Dashboard",
      products: "Products",
      categories: "Categories",
      orders: "Orders",
      contacts: "Contacts",
      visits: "Visits",
      revenue: "Revenue",
      ordersPaid: "Paid orders",
      productsCount: "Products",
      usersCount: "Customers",
      mostViewed: "Most viewed",
      visitsLast7: "Visits last 7 days",
      newProduct: "New product",
      newCategory: "New category",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      settings: "Settings",
    },
    common: {
      loading: "Loading…",
      currency: "€",
    },
  },
};
